import { Collection } from "../../Model/Collection";
import { FetchStatus } from "../../Model/FetchStatus";
import {
  ModuleTemperatureChange,
  ModuleTemperatureSensorCollection,
  TemperatureSensorCollection,
} from "../../Model/Temperature";
import { ETemperatureAction, TemperatureAction } from "../actions/TemperatureActions";
import { RootState } from "./RootReducer";

type State = {
  status: FetchStatus;
  moduleTemperatureSensorsCollection: ModuleTemperatureSensorCollection;
  moduleTemperatureChangeCollection: Collection<ModuleTemperatureChange>;
};

const initialState: State = {
  moduleTemperatureSensorsCollection: {
    allIds: [],
    byId: {},
  },
  moduleTemperatureChangeCollection: {
    allIds: [],
    byId: {},
  },
  status: {
    pending: false,
    completed: false,
    error: null,
  },
};

function updateModuleTemperatureChangeCollection(
  collection: Collection<ModuleTemperatureChange>,
  moduleTemperatureChanges: ModuleTemperatureChange[]
): Collection<ModuleTemperatureChange> {
  const result = {
    allIds: [...collection.allIds],
    byId: { ...collection.byId },
  };

  for (let moduleTemperatureChange of moduleTemperatureChanges) {
    const isIdentifierExist = result.allIds.indexOf(moduleTemperatureChange.identifier) !== -1;

    if (!isIdentifierExist) {
      result.allIds.push(moduleTemperatureChange.identifier);
    }
    result.byId[moduleTemperatureChange.identifier] = moduleTemperatureChange;
  }

  return result;
}

export function temperatureReducer(state = initialState, action: TemperatureAction): State {
  switch (action.type) {
    case ETemperatureAction.FETCH_TEMPERATURE_SENSORS_PENDING:
      return {
        ...state,
        status: {
          pending: true,
          completed: false,
          error: null,
        },
      };
    case ETemperatureAction.FETCH_TEMPERATURE_SENSORS_SUCCESS:
      if (action.temperatureSensorsCollection == null) {
        throw new Error("Temperature sensor collection is null");
      }
      return {
        ...state,
        status: {
          pending: false,
          completed: true,
          error: null,
        },
        moduleTemperatureSensorsCollection: action.temperatureSensorsCollection,
      };
    case ETemperatureAction.FETCH_TEMPERATURES_SENSORS_ERROR:
      return {
        ...state,
        status: {
          pending: false,
          completed: true,
          error: action.error,
        },
      };
    case ETemperatureAction.UPDATE_TEMPERATURE_READINGS:
      if (action.moduleTemperatureChanges == null) {
        throw new Error("Temperature reading is null");
      }
      return {
        ...state,
        moduleTemperatureChangeCollection: updateModuleTemperatureChangeCollection(
          state.moduleTemperatureChangeCollection,
          action.moduleTemperatureChanges
        ),
      };
    default:
      return state;
  }
}

export const getModuleTemperatureSensors = (state: RootState, moduleIdentifier: string): TemperatureSensorCollection =>
  state.temperatureStore.moduleTemperatureSensorsCollection.byId[moduleIdentifier];
export const getTemperatureSensorsCollection = (state: RootState) => state.temperatureStore.moduleTemperatureSensorsCollection;
export const getTemperatureSensorsFetchStatus = (state: RootState) => state.temperatureStore.status;
export const getModuleTemperatureChanged = (state: RootState, moduleIdentifier: string): ModuleTemperatureChange =>
  state.temperatureStore.moduleTemperatureChangeCollection.byId[moduleIdentifier];
export const getTemperatureChanged = (state: RootState): { [index: string]: ModuleTemperatureChange } =>
  state.temperatureStore.moduleTemperatureChangeCollection.byId;
